(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/loader-ticket/loader-ticket.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/loader-ticket/loader-ticket.js');
"use strict";


const spinnerOptions = {
  lines: 12,
  length: 18,
  width: 5,
  radius: 12,
  corners: 1,
  rotate: 0,
  direction: 1,
  color: '#e1e1e5',
  speed: 1,
  trail: 60,
  shadow: false,
  hwaccel: true,
  className: 'spinner',
  zIndex: 1,
  top: '50%',
  left: '50%',
  delayedShow: true
};
const {
  useEffect,
  useRef
} = React;
const {
  Image
} = svs.content.image_v2;
setGlobal('svs.ticketgames.ticketUtility.components.LoaderTicket', _ref => {
  let {
    image
  } = _ref;
  const containerRef = useRef(null);
  useEffect(() => {
    const spinner = new Spinner(spinnerOptions).spin(containerRef.current);
    return () => {
      spinner.stop();
    };
  }, []);
  return React.createElement("div", {
    className: "ticket-overlay",
    "data-testid": "loader-ticket",
    ref: containerRef,
    style: {
      height: '99%'
    }
  }, image && React.createElement(Image, {
    cssSelectors: "preview-ticket",
    image: image
  }));
});

 })(window);